// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"217":"8a4ef4c5","6052":"0ef5b5b5"}[chunkId] + ".chunk.css";
};